import { t } from "i18next";
import { useLocal } from "hooks/useLocal";
import { Helmet } from "react-helmet-async";
import { fetchSupportContacts } from "utils/remoteConfig";

export default function ContactSection() {
  const { supportEmail, supportPhoneNumber } = fetchSupportContacts();
  const { isArabic } = useLocal();
  const whatsappPhone = (supportPhoneNumber || "").replace(/\D/g, "");
  const isMobileDevice =
    typeof window !== "undefined" &&
    /Mobi|Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent);
  const whatsappLink = whatsappPhone
    ? isMobileDevice
      ? `https://wa.me/${whatsappPhone}`
      : `https://web.whatsapp.com/send?phone=${whatsappPhone}`
    : "https://web.whatsapp.com/";

  const contactItems = [
    // {
    //   Icon: (props: any) => (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //       {...props}
    //     >
    //       <path
    //         d="M21.9999 16.9201V19.9201C22.0011 20.1986 21.944 20.4743 21.8324 20.7294C21.7209 20.9846 21.5572 21.2137 21.352 21.402C21.1468 21.5902 20.9045 21.7336 20.6407 21.8228C20.3769 21.912 20.0973 21.9452 19.8199 21.9201C16.7428 21.5857 13.7869 20.5342 11.1899 18.8501C8.77376 17.3148 6.72527 15.2663 5.18993 12.8501C3.49991 10.2413 2.44818 7.27109 2.11993 4.1801C2.09494 3.90356 2.12781 3.62486 2.21643 3.36172C2.30506 3.09859 2.4475 2.85679 2.6347 2.65172C2.82189 2.44665 3.04974 2.28281 3.30372 2.17062C3.55771 2.05843 3.83227 2.00036 4.10993 2.0001H7.10993C7.59524 1.99532 8.06572 2.16718 8.43369 2.48363C8.80166 2.80008 9.04201 3.23954 9.10993 3.7201C9.23656 4.68016 9.47138 5.62282 9.80993 6.5301C9.94448 6.88802 9.9736 7.27701 9.89384 7.65098C9.81408 8.02494 9.6288 8.36821 9.35993 8.6401L8.08993 9.9101C9.51349 12.4136 11.5864 14.4865 14.0899 15.9101L15.3599 14.6401C15.6318 14.3712 15.9751 14.1859 16.3491 14.1062C16.723 14.0264 17.112 14.0556 17.4699 14.1901C18.3772 14.5286 19.3199 14.7635 20.2799 14.8901C20.7657 14.9586 21.2093 15.2033 21.5265 15.5776C21.8436 15.9519 22.0121 16.4297 21.9999 16.9201Z"
    //         stroke="#4242CE"
    //         strokeWidth="1.5"
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //     </svg>
    //   ),
    //   label: t("contactUs.callUsOn"),
    //   linkText: supportPhoneNumber || "+97338077373",
    //   href: `tel:${supportPhoneNumber || "+97338077373"}`,
    //   ariaLabel:
    //     t("contactUs.callUsOn") + " " + (supportPhoneNumber || "+97338077373"),
    // },
    {
      Icon: (props: any) => (
        <svg
          width="22"
          height="18"
          viewBox="0 0 22 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M20.75 2.75C20.75 1.65 19.85 0.75 18.75 0.75H2.75C1.65 0.75 0.75 1.65 0.75 2.75M20.75 2.75V14.75C20.75 15.85 19.85 16.75 18.75 16.75H2.75C1.65 16.75 0.75 15.85 0.75 14.75V2.75M20.75 2.75L10.75 9.75L0.75 2.75"
            stroke="#4242CE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      label: t("contactUs.emailUsAt"),
      linkText: supportEmail,
      href: `mailto:${supportEmail}`,
      ariaLabel:
        t("contactUs.emailUsAt") + " " + (supportEmail || "support@numuw.com"),
    },
    {
      Icon: (props: any) => (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
            stroke="#4242CE"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      label: t("contactUs.chatWithOUrTeamOn"),
      linkText: "WhatsApp",
      href: whatsappLink,
      ariaLabel: t("contactUs.chatWithOUrTeamOn") + " WhatsApp",
    },
  ];
  return (
    <>
      <Helmet>
        <title>{t("siteMap.contactUs.title")}</title>
        <meta
          name="description"
          content={t("siteMap.contactUs.description") || ""}
        />
      </Helmet>
      <main
        dir={isArabic ? "rtl" : "ltr"}
        className={`px-6 mx-auto w-full max-w-[1400px] ${isArabic ? "font-ibmplex" : "font-inter"}`}
        style={{
          padding: "48px 24px",
          textAlign: isArabic ? "right" : "left",
        }}
      >
        <section aria-labelledby="contact-heading">
          <header style={{ marginBottom: "40px" }}>
            <p
              className={`${isArabic ? "font-ibmplex" : "font-funnel"}`}
              style={{
                color: "#4242CE",
                fontSize: "16px",
                fontWeight: 700,
                borderBottom: "2.5px solid #4242CE",
                display: "inline-block",
                paddingBottom: "4px",
                marginBottom: "20px",
                letterSpacing: "0.01em",
                margin: "0 0 20px 0",
              }}
            >
              {t("contactUs.contactUs")}
            </p>
            <p
              className="font-funnel"
              id="contact-heading"
              style={{
                fontSize: "clamp(26px, 5vw, 32px)",
                fontWeight: 700,
                color: "#111827",
                lineHeight: 1.25,
                margin: 0,
              }}
            >
              {t("contactUs.reachOutToTheRegion")}
            </p>
          </header>

          <ul
            className="md:max-w-[357px] w-full"
            style={{
              listStyle: "none",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {contactItems.map(({ Icon, label, linkText, href, ariaLabel }) => (
              <li key={href}>
                <a
                  className="flex-wrap"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={href}
                  aria-label={ariaLabel}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    border: "1px solid #CCCCCC",
                    borderRadius: "12px",
                    padding: "24px",
                    textDecoration: "none",
                    transition:
                      "border-color 0.18s ease, box-shadow 0.18s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "#4242CE";
                    e.currentTarget.style.boxShadow = "0 0 0 1px #4242CE";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#CCCCCC";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <Icon
                    style={{
                      color: "#4242CE",
                      fontSize: "22px",
                      flexShrink: 0,
                    }}
                    aria-hidden="true"
                  />
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "#111827",
                    }}
                  >
                    {label}
                  </p>
                  <p className="text-[#4242CE] text-[16px]">{linkText}</p>
                </a>
              </li>
            ))}
          </ul>
        </section>
      </main>
    </>
  );
}
